import _ from 'lodash'
import 'assets/scss/form2.scss'
import { upsertFeatureSetComponentRoute } from 'api/Product'
import FormTextField from 'components/FormTextField'
import { Button, Card, Grid, Switch } from '@material-ui/core'
import React, { useCallback, useLayoutEffect, useMemo, useState } from 'react'
import { AutoCompleteNew } from 'components/Select'
import FormItem from 'components/FormItem'
import { getDBOptionsPromise } from 'api/Util'

export default function ChallengeForm (props) {
  const columnsNotNull = []
  const { data, history } = props
  const [payload, setPayload] = useState({})
  const [featureSetOptions, setFeatureSetOptions] = useState([])

  useLayoutEffect(() => {
    getDBOptionsPromise('feature_set').then(res => setFeatureSetOptions(res.feature_set))
  }, [])

  useLayoutEffect(() => {
    if (!_.isEmpty(payload)) return

    setPayload(data)
  }, [payload, data])

  const handleChange = useCallback((key, val) => {
    setPayload(prev => ({ ...prev, [key]: val }))
  }, [])

  const cancelClicked = useCallback(() => {
    history.push('/feature-set-components')
  }, [history])

  const saveClicked = useCallback(() => {
    upsertFeatureSetComponentRoute(payload)
      .then(() => history.push('/feature-set-components'))
  }, [payload, history])

  const isSaveBtnDisabled = useMemo(() => {
    for (const cname of columnsNotNull)
      if (!payload[cname]) return true
  }, [payload, columnsNotNull])

  return <div className='form-page'>
    <div className='form-head-container'>
      <div className='form-head'>
        <h2>
          {data.id ? 'Edit' : 'New'} Feature Set
        </h2>
        <span>
          <Button variant='contained' color='default' onClick={cancelClicked}>CANCEL</Button>
          &nbsp;&nbsp;&nbsp;
          <Button variant='contained' color='primary' onClick={saveClicked} disabled={isSaveBtnDisabled}>
            SAVE
          </Button>
        </span>
      </div>
    </div>

    <div className='form-elem-container'>
    <Card>
      <Grid item xs={12} className='form-card-title'>
        <label className='form-card-label'>SETUP</label>
        <Switch id='active' name={'active'} checked={Boolean(payload.active)} onChange={e => handleChange('active', e.target.checked)} />
      </Grid>

      <Grid container item xs={12} className='form-card-content' >
        <Grid item xs={12}>
          <FormTextField name='name' label='Name' value={payload.name} onChange={handleChange} />
        </Grid>

        <Grid item xs={12}>
          <FormTextField name='permanent_name' label='Permanent Name' value={payload.permanent_name} onChange={handleChange} />
        </Grid>

        <Grid item xs={12}>
          <FormItem label='Feature Set'>
            <AutoCompleteNew options={featureSetOptions} value={payload.feature_set_id} variant='outlined' inputLeft={true}
              onChange={(event, selected) => handleChange('feature_set_id', (selected || {value: null}).value) }
            />
          </FormItem>
        </Grid>

      </Grid>
    </Card>
    </div>
  </div>
}
